import {
  type AdminTranslation,
  TRANSLATION_LOCALES,
  type TranslationLocale,
} from '@/api/(admin)/translations/types';
import type {
  TranslationRow,
  TranslationsParams,
  TranslationsQueryInput,
} from '../-types';

function first(
  filters: Record<string, string[]> | undefined,
  key: string,
): string | undefined {
  const value = filters?.[key]?.[0]?.trim();
  return value ? value : undefined;
}

const isLocale = (value: string | undefined): value is TranslationLocale =>
  (TRANSLATION_LOCALES as readonly string[]).includes(value ?? '');

export function toTranslationsParams(
  input: TranslationsQueryInput,
): TranslationsParams {
  const namespace = first(input.filters, 'namespace');
  const search = first(input.filters, 'search');
  const missingLocale = first(input.filters, 'missingLocale');
  return {
    page: Math.max(1, input.page),
    count: input.limit,
    ...(namespace ? { namespace } : {}),
    ...(search ? { search } : {}),
    ...(isLocale(missingLocale) ? { missingLocale } : {}),
  };
}

export function buildTranslationsQs(params: TranslationsParams): string {
  const qs = new URLSearchParams();
  qs.set('page', String(params.page));
  qs.set('count', String(params.count));
  if (params.namespace) qs.set('namespace', params.namespace);
  if (params.search) qs.set('search', params.search);
  if (params.missingLocale) qs.set('missingLocale', params.missingLocale);
  return qs.toString();
}

export const toTranslationRow = (row: AdminTranslation): TranslationRow => ({
  ...row,
  id: `${row.namespace}:${row.key}`,
});
